import { idGenerator } from "Util/uniqueIdGenerator";
import { ENVELOPE_ITEM_TYPE, ENVELOPE_RECIPIENT_CONTACT_INFO_TYPE } from "./editEnvelopeStore";
import { SIGNATORY_DATA_FORMAT_TYPE } from "TemplateTags/templateTagTypes";

const _idGenerator = new idGenerator();

export function getNewEnvelopeItem(index, type, sourceId) {
    const newItem = {
        PublicId: _idGenerator.getNextId("envelope_item_public_id_"),
        Type: type,
        IsRequired: false,
        Order: index + 1, // Order should start at 1 so we know it isn't empty
        AttachmentDefinitionId: null,
        ContentItemId: null,
        DocumentTemplateDefinitionId: null,
        TargetAttachmentDefinitionId: null,
        IsIncludedFormulaId: null,
        Label: null
    };

    switch (type) {
        case ENVELOPE_ITEM_TYPE.Attachment:
            newItem.AttachmentDefinitionId = sourceId;
            break;
        case ENVELOPE_ITEM_TYPE.ContentItem:
            newItem.ContentItemId = sourceId;
            break;
        case ENVELOPE_ITEM_TYPE.DocumentTemplate:
            newItem.DocumentTemplateDefinitionId = sourceId;
            break;
        default:
            throw `Unhandled item type ${type}`;
    }

    return newItem;
}

export function getNewEnvelopeRecipient(type, label) {
    const newRecipient = {
        PublicId: _idGenerator.getNextId("envelope_recipient_public_id_"),
        Label: label,
        Type: type,
        FirstNameFieldId: null,
        LastNameFieldId: null,
        EmailFieldId: null,
        UserFieldId: null,
        RoutingOrder: null,
        Message: null,
        ContactInfoType: ENVELOPE_RECIPIENT_CONTACT_INFO_TYPE.IndividualFields
    };
    return newRecipient;
}

export function getNewEnvelopeFieldMapping(itemId, recipientId, tag, mergeLinkTemplateId) {
    const newMapping = {
        PublicId: _idGenerator.getNextId("envelope_field_mapping_public_id_"),
        ItemId: itemId,
        RecipientId: recipientId,
        TagType: tag.TagType,
        SignatoryTagNumber: tag.SignatoryTagNumber,
        DataTarget: null,
        MergeLinkTemplateId: mergeLinkTemplateId,
        Properties: { Format: SIGNATORY_DATA_FORMAT_TYPE.UNRESTRICTED, IsRequired: true }
    };
    return newMapping;
}
